import http from "./http";

type QueryPrimitive = string | number | boolean;
export type ReporteFiltros = Record<string, QueryPrimitive | QueryPrimitive[] | undefined> & {
  verJefe?: boolean;
};

const buildQueryFilters = (filters: Record<string, QueryPrimitive | QueryPrimitive[] | undefined>): string[] => {
  return Object.keys(filters)
    .map((key) => {
      const filterValue = filters[key];
      return Array.isArray(filterValue)
        ? filterValue.map((val) => `${key}=${encodeURIComponent(val)}`).join('&')
        : `${key}=${encodeURIComponent(filterValue ?? '')}`;
    });
};

function buildQueryParamsText(filters: Record<string, QueryPrimitive | QueryPrimitive[] | undefined> = {}): string {
  const params = filters ? buildQueryFilters(filters) : [];
  return params.length > 0 ? `?${params.join('&')}` : '';
}

export const getReporte = async (tipoReporte?: string, desde?: string | null, hasta?: string | null, filtros?: ReporteFiltros, query?: Record<string, QueryPrimitive>) => {
  try {
    const verJefe = filtros ? !!filtros.verJefe : false;
    if (filtros) delete filtros.verJefe;
    const params = {
      desde: desde || '',
      hasta: hasta || '',
      consulta: JSON.stringify(filtros || {}),
      verJefe,
      ...query,
    };
    const consulta = buildQueryParamsText(params);
    return http.get(`/app/reporte/generico/${tipoReporte}${consulta}`);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return null;
  }
};

export const downloadReporteExcel = async (tipoReporte?: string, desde?: string | null, hasta?: string | null, filtros?: ReporteFiltros, filename?: string) => {
  try {
    const verJefe = filtros ? !!filtros.verJefe : false;
    if (filtros) delete filtros.verJefe;
    const params = {
      desde: desde || '',
      hasta: hasta || '',
      consulta: JSON.stringify(filtros || {}),
      verJefe
    };
    const consulta = buildQueryParamsText(params);
    filename = filename || getFileName("Colegio Alemán", tipoReporte);
    return http.download(`/app/reporte/generico/${tipoReporte}/excel${consulta}`, filename);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return null;
  }
};

export const downloadReportePDF = async (tipoReporte?: string, desde?: string | null, hasta?: string | null, filtros?: ReporteFiltros, filename?: string) => {
  try {
    const verJefe = filtros ? !!filtros.verJefe : false;
    if (filtros) delete filtros.verJefe;
    const params = {
      desde: desde || '',
      hasta: hasta || '',
      consulta: JSON.stringify(filtros || {}),
      verJefe
    };
    const consulta = buildQueryParamsText(params);
    filename = filename || getFileName("Colegio Alemán", tipoReporte);
    return http.download(`/app/reporte/generico/${tipoReporte}/pdf${consulta}`, filename);
  } catch (error) {
    console.error("[get] Error :: ", error);
    return null;
  }
};

export const obtenerKardexListadoEstudiantes = async (tipoReporte = 'KARDEX_LISTADO_ESTUDIANTES', desde?: string | null, hasta?: string | null, filtros?: ReporteFiltros) => {
  try {
    const params = {
      desde: desde || '',
      hasta: hasta || '',
      consulta: JSON.stringify(filtros || {}),
    };
    const consulta = buildQueryParamsText(params);
    return await http.get(`/app/reporte/generico/${tipoReporte}${consulta}`);
  } catch (error) {
    console.error("[buscar] Error :: ", error);
    return null;
  }
};

export const obtenerKardexReporteEstudiante = async (tipoReporte = 'KARDEX_REPORTE_ESTUDIANTE', desde?: string | null, hasta?: string | null, filtros?: ReporteFiltros) => {
  try {
    const params = {
      ...(desde && { desde }),
      ...(hasta && { hasta }),
      consulta: JSON.stringify(filtros || {}),
    };
    const consulta = buildQueryParamsText(params);
    return http.get(`/app/reporte/generico/${tipoReporte}${consulta}`);
  } catch (error) {
    console.error("[reporte] Error :: ", error);
    return null;
  }
};

function normalizeText(text: string) {
  let result = text.replace(/^\s+|\s+$/g, '').toLowerCase();
  const from = 'ãàáäâèéëêìíïîõòóöôùúüûç·/_,:;';
  const to = 'aaaaaeeeeiiiiooooouuuuc------';
  for (let i = 0; i < from.length; i++) {
      result = result.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  return result
      .replace(/[^a-z0-9ñ -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
}

function getFileName(title: string, subtitle?: string) {
  const primaryTitle = `${normalizeText(title)}_`;
  const secondaryTitle = subtitle ? `${normalizeText(subtitle)}_` : '';
  const date = Date.now();
  const filename = `${primaryTitle}${secondaryTitle}${date}`;
  return filename;
}
